import { render, staticRenderFns } from "./FrecuenciaBorrarModal.vue?vue&type=template&id=835e4954"
import script from "./FrecuenciaBorrarModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FrecuenciaBorrarModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports